import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * Green verified-seller badge shown when seller has 3+ completed sales.
 *  props.compact — icon-only pill (marketplace card overlay)
 *  props.hidden — force hide (avoid layout gap)
 */
export default function VerifiedBadge({ compact = false, className = '', dataTestId = 'verified-badge' }) {
  if (compact) {
    return (
      <span
        title="Verified Seller — 3+ completed sales"
        className={`inline-flex items-center gap-1 bg-emerald-500/90 text-black px-1.5 py-0.5 text-[9px] font-mono uppercase tracking-widest backdrop-blur-md ${className}`}
        data-testid={dataTestId}
      >
        <BadgeCheck className="w-3 h-3" /> Verified
      </span>
    );
  }
  return (
    <span
      title="Verified Seller — 3+ completed sales"
      className={`inline-flex items-center gap-1.5 bg-emerald-500 text-black px-2.5 py-1 text-[11px] font-mono uppercase tracking-widest ${className}`}
      data-testid={dataTestId}
    >
      <BadgeCheck className="w-3.5 h-3.5" /> Verified Seller
    </span>
  );
}
